import React, { Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import JumboApp from "@jumbo/components/JumboApp";
import AppLayout from "./AppLayout";
import JumboTheme from "@jumbo/components/JumboTheme";
import AppRoutes from "./AppRoutes";
import configureStore, { history } from "./redux/store";
import AppProvider from "./AppProvider";
import { config } from "./config/main";
import Div from "@jumbo/shared/Div";
import { CircularProgress } from "@mui/material";
import JumboAuthProvider from "@jumbo/components/JumboAuthProvider";
import { IdleTimerProvider } from "react-idle-timer";
import routes, { routesForAuthenticatedOnly } from "./routes";
import appConfig from "app/config/appConfig";
import { removeToken } from "@jumbo/components/JumboAuthProvider/authHelpers";
import { Helmet } from "react-helmet-async";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const store = configureStore();

function getInitialLayout() {
  const matched = routes.find(r => r.path === window.location.pathname);
  return matched?.element?.props?.layout || config.defaultLayout;
}

function App() {
  React.useEffect(() => {
    if (!sessionStorage.getItem("auth")) {
      if (
        routesForAuthenticatedOnly
          .map((m) => m.path)
          .includes(window.location.pathname) &&
        !window.location.pathname.includes("/micrositeLupaPassword")
      ) {
        removeToken();
      }
    }
  }, []);

  const onIdle = () => {
    if (
      routesForAuthenticatedOnly
        .map((m) => m.path)
        .includes(window.location.pathname) &&
      !window.location.pathname.includes("/micrositeLupaPassword")
    ) {
      removeToken();
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter history={history}>
          <AppProvider>
            <JumboApp activeLayout={getInitialLayout()}>
              <Helmet>
                <meta
                  httpEquiv="Content-Security-Policy"
                  content={`
                      default-src 'self' https://www.google.com https://*.google.com;
                      script-src 'self';
                      script-src-elem 'self' https://www.gstatic.com https://*.gstatic.com;
                      font-src 'self' https://cdnjs.cloudflare.com;
                      img-src 'self';
                      style-src 'self' 'unsafe-inline';
                      connect-src 'self' https://uat-via06.generali.co.id https://via06.generali.co.id;
                `}
                ></meta>
              </Helmet>
              <JumboTheme init={config.theme}>
                <JumboAuthProvider>
                  <IdleTimerProvider
                    timeout={appConfig.idleTimeout * 60000}
                    onIdle={onIdle}
                  >
                    <AppLayout>
                      <Suspense
                        fallback={
                          <Div
                            sx={{
                              display: "flex",
                              minWidth: 0,
                              alignItems: "center",
                              alignContent: "center",
                              height: "100%",
                            }}
                          >
                            <CircularProgress sx={{ m: "-40px auto 0" }} />
                          </Div>
                        }
                      >
                        <AppRoutes />
                      </Suspense>
                    </AppLayout>
                  </IdleTimerProvider>
                </JumboAuthProvider>
              </JumboTheme>
            </JumboApp>
          </AppProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
